import { Box, Button, Paper } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  GET_CLASS_LIST,
  GET_CLASSBATCHMAPPING_LIST,
  GET_YEAR_LIST,
} from "utils/graphql/services/entities/queries";
import entitesClient from "utils/graphql/entitiesClient";
import { useEffect, useState } from "react";
import Loader from "pages/build-test/loader";
import SectionTable from "shared/organisms/tables/table";

import NoDataFound from "shared/molecules/no-data";
import { table, tableRead } from "./helper";
import { YearFilter } from "./filter";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";
import { DELETE_YEAR } from "utils/graphql/services/entities/mutations";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { getAcademicYearListData } from "utils/metadata-split/metaDataApiFetch";
import { academicTagsUser, checkFeatureAccess } from "utils/role-restriction/helper";

const useStyles: any = makeStyles((indigoTheme) => ({
  label: {
    textDecoration: "none",
    textAlign: "center",
    color: indigo[700],
    marginLeft: "80%",
  },
  Btn: {
    backgroundColor: "#3f50b5",
    color: "white",
    width: "90px",
  },
  BtnWrapper: {
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
}));

export function YearEntitie() {
  const classes = useStyles();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [searchPayload, setSearchPayload] = useState({});
  const [clearValuesTrigger, setClearValuesTrigger] = useState(false);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [getYears, { loading, error, data }] = useLazyQuery(GET_YEAR_LIST, {
    client: entitesClient,
  });
  const [deleteYear, { loading: loadingD, error: errorD, data: dataD }] =
    useMutation(DELETE_YEAR, {
      client: entitesClient, // Ensure you're using the correct GraphQL client instance
    });

  const { isLoading, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );

  const { profileData } = useAppSelector((state) => state.gmailLoginReducer);
  const {role:userRoleStr}= profileData;
  const userRole = userRoleStr?.split(",");

  const updateMetaData = (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    dispatch(metadataSuccess(metadataList));
  };

  const handleUpdateYearListDate = async () => {
    try {
      const call1: any = await getAcademicYearListData(updateMetaData);
      updateMetaData(call1[0], call1[1]);
    } catch (error) {
    }
  };

  const handleEdit = (objectId,isArchieve) => {
    history.push(`/entities/year/edit?objectId=${objectId}&isArchived=${isArchieve}`);
  };

  const handleDeleteYear = async (objectId) => {
    try {
      const response: any = await deleteYear({
        variables: { objectId },
      });

      if (response?.data?.deleteYear?.success) {
        dispatch(snackbarRequest({ message: "Year deleted successfully" }));
        await handleUpdateYearListDate();
        setClearValuesTrigger(!clearValuesTrigger);
      } else {
        dispatch(
          snackbarRequest({
            message: `${response?.errorReason}`,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(snackbarRequest({ message: `${err}`, type: "error" }));
    }
  };

  useEffect(() => {
    getYears({ variables: { filter: {...searchPayload,limit,offset} } });
  }, [searchPayload, offset]);

  const hasModificationAccess = checkFeatureAccess(
    userRole,academicTagsUser.ACADEMIC_TAGS_READ_WRITE
  );

  return (
    <div>
      {hasModificationAccess && (
        <ContentRight>
          <Link to="year/create" className={classes.label}>
            <Button variant="contained"> Create AcademicYear</Button>
          </Link>
        </ContentRight>
      )}
      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
        AcademicYear
      </TypographyHeading>
      <YearFilter
        setSearchPayload={setSearchPayload}
        setOffset={setOffset}
        clearValuesTrigger={clearValuesTrigger}
      />
      <Paper elevation={2} sx={{ px: 2, pb: 4, pt: 2, mt: 2 }}>
        <div>
          {loading && <Loader />}
          {!loading && data?.getYear.length > 0 ? (
            <SectionTable
              data={data?.getYear}
              table={hasModificationAccess===true?table:tableRead}
              id="objectId"
              name="objectId"
              handleEdit={handleEdit}
              handleCopy={""}
              handleDelete={handleDeleteYear}
              rowsPerPageCount={
                data?.getYear?.length > 0 ? data?.getYear?.length : 10
              }
              style="false"
              totlaRecords={0}
              paginationSegment="false"
              viewSecondaryData="false"
            />
          ) : (
            <div>{!loading && <NoDataFound message="No Data" />}</div>
          )}
        </div>
        <Box className={classes.BtnWrapper}>
          <Button
            onClick={() => {
              setOffset(offset - 10);
            }}
            className={classes.Btn}
            disabled={offset == 0}
            variant="contained"
            size="medium"
          >
            prev
          </Button>
          <Button
            onClick={() => {
              setOffset(offset + 10);
            }}
            className={classes.Btn}
            disabled={data?.getYear?.length <= 9}
            variant="contained"
            size="medium"
          >
            next
          </Button>
        </Box>
      </Paper>
    </div>
  );
}
